import ContactNote from 'types/ContactNote';
import { getRmFullName } from 'utils/contactNoteUtil';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const contactNoteSlice = createSlice({
  name: 'CONTACT_NOTES',
  initialState: [] as ContactNote[],
  reducers: {
    createContactNote: (state, action: PayloadAction<ContactNote>) => {
      return [...state, action.payload];
    },
    updateContactNote: (state, action: PayloadAction<ContactNote>) => {
      const id = action.payload.id;
      return state.map((cn: ContactNote) => (cn.id === id ? { ...action.payload } : cn));
    },
    initContactNotes: (_, action: PayloadAction<ContactNote[]>) => {
      const contactNotes = action.payload;
      return contactNotes.map((contactNote: ContactNote) => {
        return {
          ...contactNote,
          partnerFullName: contactNote.partner.fullName,
          responsibleRmFullName: getRmFullName(contactNote),
        };
      });
    },
  },
});

export const { createContactNote, updateContactNote, initContactNotes } = contactNoteSlice.actions;
export default contactNoteSlice.reducer;
